import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { LoadingService } from '../../services/loading/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  requestCounter = 0;

  constructor(private loadingService: LoadingService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loadingService.show();
    this.requestCounter++;
    return next.handle(request).pipe(
      tap((httpEvent: HttpEvent<unknown>) => {
        if(httpEvent instanceof HttpResponse) {
          this.requestCounter--;
          if(!this.requestCounter)
            this.loadingService.hide();
        }
        return httpEvent;
      }),
      catchError((err) => {
        this.requestCounter = 0;
        this.loadingService.hide();
        return throwError(err)
      })
    );
  }

}
